module.exports = __webpack_public_path__ + "img/ingenieur-son.22b9fa0e.jpg";